import { GcpRequestData, useUploadStore } from '../../../../../../store/uploadStore';
import { Customer, Site } from '../../../../../../types';
import { trackAction } from '../../../../../../libs/analytics/ActionTracking';

export const useSwitchToEditMode = (customer: Customer, site: Site, gcpRequest?: GcpRequestData) => {
  const { setGcpRequest } = useUploadStore();

  return () => {
    if (!gcpRequest) return;

    gcpRequest.meta.isEditMode = true;
    gcpRequest.meta.areServiceHoursConfirmed = false;

    trackAction('Switch GCP Request to edit mode', { customer, site });

    setGcpRequest(customer.id, site.id, gcpRequest);
  };
};
